import React, { useState,useEffect } from 'react'
import authService from '../../api-authorization/AuthorizeService'
import { useSelector, useDispatch  } from 'react-redux'
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { selectAllEvents, fetchEvents } from './eventsSlice'
import InfoIcon from '@mui/icons-material/Info'
import HotelIcon from '@mui/icons-material/Hotel'
import CellTowerIcon from '@mui/icons-material/CellTower'
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

const EventExcerpt = ({ event }) => {
    return (
        <article >
            <h3>{event.eventName}</h3>
            <p>{event.eventDescription.substring(0, 100)}</p>
            <Link to={`/events/${event.eventId}`}>
                View Event
            </Link>
        </article>
    )
}


export default function EventsList(props) {

    const dispatch = useDispatch()

    const events = useSelector(selectAllEvents)

    const eventStatus = useSelector(state => state.events.status)

    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState();
    const [idType, setIdType] = useState();
    const [playerId, setPlayerId] = useState();
    const [userRole, setUserRole] = useState("");

    //if (eventStatus == 'succeeded') {
    //    alert("haha");
    //    const data = events[0].data
    //}
    const error = useSelector(state => state.events.error)

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                setUserName(user.sub);
                if (user.sub.includes("fide")) {
                    setIsPlayer(true);
                    setIdType("fide");
                    setPlayerId(user.sub.replace("fide", ""));
                } else if (user.sub.includes("affiliate")) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                }
                else if (user.sub.includes("uscf")) {
                    setIsPlayer(true);
                    setIdType("uscf");
                    setPlayerId(user.sub.replace("uscf", ""));
                }

                await setUserRole(role);
                if (role.includes('Administrators'))
                    setIsAdmin(true);
            }
            if (eventStatus === 'idle') {
                dispatch(fetchEvents())
            }
        }
        fetchData();
    }, [eventStatus, dispatch])
    //}, [eventStatus, dispatch])

    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        //{
        //    name: 'eventState',
        //    label: 'State',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //        customLabelHeadRender: (columnMeta, updateDirection) => (
        //            <th style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
        //                {columnMeta.label}
        //            </th>
        //        ),
        //    }
        //},
        {
            name: "eventLocation",
            label: "LOCATION",
            options: {
                filter: false,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "140px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let event = events[originalIndex];
                    return (
                        <div style={{ position: "relative", height: "20px", width: "140px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    {"["+event.eventState+"] " +event.eventCity}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventState",
            label: "State",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "30px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "30px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    {value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventCity",
            label: "CITY",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "80px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "80px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                        {value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventStartDateTime",
            label: "START DATE",
            options: {
                filter: true,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "140px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "140px" }} title={value}>
                            <div style={{ textAlign: "left" }}>
                                <span>{value.split("T")[0]}</span>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventEndDateTime",
            label: "END DATE",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "140px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "140px" }} title={value}>
                            <div style={{ textAlign: "left" }}>
                                <span>{value.split("T")[0]}</span>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventType",
            label: "TYPE",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "80px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "80px" }} title={value}>
                            <div style={{ textAlign: "left" }}>
                                <span>{value}</span>
                            </div>
                        </div>
                    );
                }
            }
        },
        //{
        //    name: 'eventStartDateTime',
        //    label: 'Start Date',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //        customLabelHeadRender: (columnMeta, updateDirection) => (
        //            <th style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
        //                {columnMeta.label}
        //            </th>
        //        ),
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            return (
        //                <div style={{ textAlign: "left" }}>
        //                    <span>{value.split("T")[0]}</span>
        //                </div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: 'eventType',
        //    label: 'Type',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: 'eventFormat',
        //    label: 'Format',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: "eventFormat",
        //    label: "FORMAT",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customLabelHeadRender: (columnMeta, updateDirection) => (
        //            <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "80px" }}>
        //                {columnMeta.label}
        //            </th>
        //        ),
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
        //            const formatObj = {
        //                INP: 'In Person',
        //                HYB: 'Hybrid',
        //                OLN: 'Online',
        //                OTH: 'Other',
        //            };
        //            let parentStyle = {
        //                position: "absolute",
        //                top: 0,
        //                right: 0,
        //                bottom: 0,
        //                left: 0,
        //                boxSizing: "border-box",
        //                display: "block",
        //                width: "100%"
        //            };
        //            let cellStyle = {
        //                boxSizing: "border-box",
        //                overflow: "hidden",
        //                textOverflow: "ellipsis",
        //                whiteSpace: "nowrap",
        //                textAlign: "left"
        //            };
        //            let eventId = events[originalIndex].id;
        //            return (
        //                <div style={{ position: "relative", height: "20px", width: "80px" }} title={value}>
        //                    <div style={{ textAlign: "left" }}>
        //                        <span>{formatObj[value]}</span>
        //                    </div>
        //                </div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: 'eventRounds',
        //    label: 'Rnd',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        {
            name: "eventRounds",
            label: "RND",
            options: {
                filter: true,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "40px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "40px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    {value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },

        {
            name: "eventPrizeFund",
            label: "Prize",
            options: {
                filter: true,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "60px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "60px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    ${value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },

        {
            name: "eventName",
            label: "NAME",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "300px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    /*let eventId = events[originalIndex].id;*/
                    let event = events[originalIndex];
                    return (
                        <div style={{ position: "relative", height: "20px", width: "300px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    <Link to={`/events/${event.eventID}`}>
                                        {/*{value.substring(0, 49)}*/}
                                        {/*{value.length > 50 ? '...' : ''}*/}
                                        {value}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "",
            label: "QUICK LINKS",
            options: {
                filter: false,
                filterType: 'multiselect',
                sort: false,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let event = events[originalIndex];
                    return (
                        <div style={{ textAlign: "left" }}>
                            {event.eventFlyerUrl ? <a href={event.eventFlyerUrl} target="_blank" title="Event Details"><InfoIcon color="primary" /></a> : <InfoIcon color="disabled"/>}
                            {event.eventRegistrationUrl ? <a href={event.eventRegistrationUrl} target="_blank" title="Register"><PersonAddIcon color="primary" /></a> : <PersonAddIcon color="disabled"/>}
                            {event.eventPairingUrl ? <a href={event.eventPairingUrl} target="_blank" title="Pairing and Results"><AssessmentIcon color="primary"/></a> : <AssessmentIcon color="disabled"/>}
                            {event.eventLiveGameUrl ? <a href={event.eventLiveGameUrl} target="_blank" title="Live Games"><CellTowerIcon color="primary"/></a> : <CellTowerIcon color="disabled"/>}
                            {event.eventHotelReservationLink ? <a href={event.eventHotelReservationLink} target="_blank" title="Hotel Reservation"> <HotelIcon color="primary"/></a> : <HotelIcon color="disabled"/>}
                           
                            {/*<FontAwesomeIcon icon={faChess} />*/}
                            {/*<FontAwesomeIcon icon={faCircleInfo} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faClipboardUser} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faSquarePollVertical} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faTowerBroadcast} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faBed} size="lg" />*/}
                        </div>
                    );
                }


            }
        },

        //{
        //    name: "fideWomenTitle",
        //    label: "Women Title",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "fideBirthday",
        //    label: "Birthday Year",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "fideCountry",
        //    label: "Flag",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortOrder: { name: 'id', direction: 'desc' },
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <div>
        //                <PlayerFlag key={value} code={(value === "" || value === null || value === undefined) ? "USA" : value} />
        //            </div>
        //        )
        //    }
        //},
        //{
        //    name: "fideCountry",
        //    label: "Country",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <div>
        //                <span>{value ? value : "USA"}</span>
        //            </div >

        //        )
        //    }
        //},
        //{
        //    name: "uscfState",
        //    label: "State",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <span>
        //                {value === "" ? "--" : value}
        //            </span>
        //        )
        //    }
        //},
        //{
        //    name: "fideName",
        //    label: "Name",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <span>
        //                {/*{value === "" ? tableMeta.tableData[tableMeta.currentTableData[tableMeta.rowIndex].index].uscfName : value}*/}
        //                {value ? value : players[tableMeta.currentTableData[tableMeta.rowIndex].index].uscfName}
        //            </span>
        //        )
        //    }
        //},
        //{
        //    name: "fidePlayerId",
        //    label: "FIDE ID",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            return (
        //                <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: "fideRating",
        //    label: "Elo",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: "fideBlitzRating",
        //    label: "FIDE Blitz",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "fideRapidRating",
        //    label: "FIDE Rapid",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfPlayerId",
        //    label: "USCF ID",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            return (
        //                <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: "uscfRating",
        //    label: "Rating",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: "uscfOnlineRating",
        //    label: "USCF Online",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfBlitzRating",
        //    label: "USCF Blitz",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfOnlineBlitzRating",
        //    label: "USCF Online Blitz",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfQuickRating",
        //    label: "USCF Quick",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfOnlineQuickRating",
        //    label: "USCF Online Quick",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "",
        //    label: "",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
        //            let rowPlayer = players[originalIndex];
        //            return (
        //                <div style={{ textAlign: "left" }}> <Button variant="contained" onClick={async (e) => { e.preventDefault(); await setSelectedPlayer(rowPlayer) }}>Games</Button></div>
        //            );
        //        }
        //    }
        //},
    ];

    const HeaderElements = () => (
        <>
            {(isOrganizer || isAdmin) &&
                <Button component={Link} to={'/Events/Add'} variant="contained" color="primary">+ New Event</Button>
            }
        </>
    );

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: "vertical",
        expandableRows: false,
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        download: false,
        print: false,
        rowsPerPage: [10],
        rowsPerPageOptions: [5, 10, 15, 25, 50],
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        customToolbar: () => (<HeaderElements />),
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
        //onRowClick: (rowData, rowMeta) => {
        //    const detail = players[rowMeta.dataIndex];
        //    console.log(detail);
        //    if (props.sendToParentSelectedPlayer) {
        //        props.sendToParentSelectedPlayer(detail)
        //    }
        //    if (detail.fidePlayerId > 0) {
        //        if (props.sendToParentIdType) {
        //            props.sendToParentIdType("FIDE")
        //        }
        //        if (props.sendToParentPlayerId) {
        //            props.sendToParentPlayerId(detail.fidePlayerId)
        //        }
        //    } else {
        //        if (props.sendToParentIdType) {
        //            props.sendToParentIdType("USCF")
        //        }
        //        if (props.sendToParentPlayerId) {
        //            props.sendToParentPlayerId(detail.uscfPlayerId)
        //        }
        //    }
        //}
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
            MUIDataTableBodyRow: {
                root: {
                    '&:nth-child(odd)': {
                        backgroundColor: '#FF0000'
                    }
                }
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    return (
        <section>
            {events &&
                <Box sx={{ width: '100%', mt: 2, mb: 1, }}>
                <Accordion m={2} pt={3} pl={0} pr={0} defaultExpanded={true}>
                    <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2' }}>
                        <Typography color='white'>Chess Events - <Link to="/Identity/Account/Register" style={{ color: 'white', textDecoration: 'underline' }}>Register</Link> an organizer account and publish your events to 5000+ players for free!</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid item xs={12}>
                                <CacheProvider value={muiCache}>
                                    <ThemeProvider theme={theme}>
                                        <MUIDataTable
                                            title={""}
                                            data={events}
                                            columns={columns}
                                            options={options}
                                            components={components}
                                        />
                                    </ThemeProvider>
                                </CacheProvider>
                        </Grid>
                    </AccordionDetails>
                    </Accordion>
                </Box>
            }
        </section>
    )
}